// 纳税信息
import { i18n } from '@/common/utils/i18n'
import { get } from 'lodash-es'

export default (state) => {
  let contractInfo = get(state, 'currentContractorDetail.contractInfo', {})
  // let contractorInfo = get(state, 'currentContractorDetail.contractorInfo', {})
  return {
    title: i18n.gettext('纳税信息'),
    content: [
      {
        title: i18n.gettext('税号'),
        label: contractInfo.taxId
      },
      {
        title: i18n.gettext('纳税照片'),
        content: i18n.gettext('查看'),
        arrow: true,
        isLink: true,
        pics: contractInfo.taxPics
      }
    ]
  }
}
